import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-federated-help-dialog',
  templateUrl: './federated-help-dialog.component.html'
})
export class FederatedHelpDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<FederatedHelpDialogComponent>, public dialog: MatDialog) { }

  ngOnInit() {

  }

}
